'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navbar = require('./navbar.html');

var _navbar2 = _interopRequireDefault(_navbar);

var _navbar3 = require('./navbar.controller');

var _navbar4 = _interopRequireDefault(_navbar3);

require('./navbar.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navbarComponent = {
  restrict: 'E',
  bindings: {
    hideGlobalFilters: '<',
    globalFilterOptions: '<'
  },
  template: _navbar2.default,
  controller: _navbar4.default,
  controllerAs: 'vm'
};

exports.default = navbarComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/navbar/navbar.component.js
 **/